import { type components } from '@/generated/internal-api/openapi-types';

export type WorkflowTemplateSummary = components['schemas']['WorkflowTemplateSummaryV1'];

/** Mirrors the API limit on saved templates per study. */
export const MAX_WORKFLOW_TEMPLATES_PER_STUDY = 20;

const timestamp = (value: string | null): number => (value === null ? Number.NEGATIVE_INFINITY : Date.parse(value));

const newestFirst = (left: string | null, right: string | null): number => {
  const leftTime = timestamp(left);
  const rightTime = timestamp(right);
  if (leftTime === rightTime) {
    return 0;
  }
  return rightTime > leftTime ? 1 : -1;
};

/**
 * Orders templates the way the API lists them: most recently used first, then never-used ones,
 * newest first. Names break ties so the order is stable.
 */
export const sortTemplatesByRecentUse = (templates: Array<WorkflowTemplateSummary>): Array<WorkflowTemplateSummary> =>
  [...templates].sort((left, right) => {
    const byLastUse = newestFirst(left.last_used_at, right.last_used_at);
    if (byLastUse !== 0) {
      return byLastUse;
    }
    const byCreation = newestFirst(left.created_at, right.created_at);
    if (byCreation !== 0) {
      return byCreation;
    }
    return left.name.localeCompare(right.name, undefined, { sensitivity: 'base', numeric: true });
  });
